/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Liwg
 * @date  2024/09/11 14:32
 * @des  需要国际化的中文
 */

module.exports = {
  common_common: {
    appName: '小雨优学',
    handelSuccess: '操作成功',
    handelFail: '操作失败',
    requestErr: '获取数据失败',
    delete: '删除',
    account: {
      loggedOff: '账号已注销',
      blocked: '账号已冻结',
    },
    timeUtil: {
      justNow: '刚刚',
      minuteAgo: '{time}分钟前',
      yesterday: '昨天 {time}',
      day: '天',
      hour: '小时',
      minute: '分钟',
      seconds: '秒'
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/i18n/cn.js